module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sprite"
  }, [_c('canvas', {
    attrs: {
      "id": _vm.spriteId,
      "width": _vm.spriteW,
      "height": _vm.spriteH
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3248aec2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprite.vue
// module id = 12
// module chunks = 0